/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Action/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromFormat from 'Data/format.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import Tysiav2FilterIcon2 from 'DesignSystem/Svgs/Tysiav2FilterIcon2/index'



/** @type {import('Simple/types.js').View} */
export default function Action({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/LowerSection/FilterAction/Action"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let settingsSelectedAppointmentTemplatesValueData = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'selected_appointment_templates',
format: fromFormat.isNotEmptyList,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: settingsSelectedAppointmentTemplatesValueData,
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let settingsSelectedAppointmentTemplatesValueData1 = fromData.useDataFormat({ viewPath,
context: 'settings',
path: 'selected_appointment_templates',
format: fromFormat.isNotEmptyList,
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 height={dtSpaceM}
 paddingLeft={dtSpaceLs}
 paddingRight={dtSpaceLs}
>
{childProps => (
<React.Fragment>
<Tysiav2FilterIcon2
{...childProps}
  viewPath={`${viewPath}/Tysiav2FilterIcon2`}
 fill2={settingsSelectedAppointmentTemplatesValueData1 ? dtColorsNeutral900 : dtColorsNeutral400}
 data="settings.selected_appointment_templates"
 format="/Data/format.js isNotEmptyList"
/>
<fromFlow.When is={flowValue === 'No'}>
<No
{...childProps}
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
{...childProps}
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
{children}
</React.Fragment>)
}